import {useEffect,useRef,useState} from 'react';
import {geoRequest} from './service';

// Keep successful data during a manual retry; invalidate pending work when the point/view changes.
export function useGeoLookup(operation,input,{enabled=true,...context}={}) {
  const [data,setData]=useState(null),[error,setError]=useState(null),[busy,setBusy]=useState(false);
  const [wait,setWait]=useState(null);
  const [revision,setRevision]=useState(0);
  const key=JSON.stringify([enabled,operation,input,context.qr,context.endpoint,context.grant,context.version]);
  const current=useRef();current.current={operation,input,context,enabled,key};
  const previous=useRef(null),manualKey=useRef(null),busyRef=useRef(false);
  useEffect(()=>{
    const value=current.current;
    if(previous.current!==key){setData(null);manualKey.current=null;previous.current=key;}
    setError(null);setWait(null);
    if(!value.enabled || !value.input){setBusy(false);busyRef.current=false;return;}
    const controller=new AbortController();setBusy(true);busyRef.current=true;
    geoRequest(value.operation,value.input,{...value.context,signal:controller.signal,autoRetry:manualKey.current!==key,onWait:value=>{if(!controller.signal.aborted)setWait(value);}})
      .then(result=>{if(!controller.signal.aborted)setData(result);})
      .catch(failure=>{if(!controller.signal.aborted)setError(failure);})
      .finally(()=>{if(!controller.signal.aborted){setBusy(false);setWait(null);busyRef.current=false;}});
    return ()=>{controller.abort();busyRef.current=false;};
  },[key,revision]);
  const retry=()=>{
    if(busyRef.current || !enabled || !input)return;
    busyRef.current=true;manualKey.current=key;setRevision(value=>value+1);
  };
  const sameInput=previous.current===key;
  return {wait:sameInput?wait:null,data:sameInput?data:null,error:sameInput?error:null,busy:sameInput?busy:enabled && !!input,retry};
}
